import { trans } from "@/_providers/Translation"

function Integrations() {
  return (
    <div style={{ width: "100%" }}>
      <div className="head">
        <h3
          style={{
            marginBottom: 0,
          }}
        >
          Интеграции
        </h3>
        <button className="button button-small button-edit" onClick={() => {}}>
          {trans("buttons.editAction")}
        </button>
      </div>
      <hr />

      <div className="table-scroller">
        <table className="settings">
          <tbody>
            <tr>
              <td style={{ width: "40%" }}>
                <b>Aircall Token</b>
              </td>
              <td>-</td>
            </tr>
            <tr>
              <td style={{ width: "40%" }}>
                <b>ASWO API Key</b>
              </td>
              <td>-</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default Integrations
